@if (userListLoaded()) {
  <div class="mb-3">
    <div [class]="isMobile() ? 'relative' : 'border-b-ui-gray-light border-b flex justify-between items-center'">
      <mat-button-toggle-group
        (valueChange)="userStatusFilter.set($event)"
        [class]="isMobile() ? 'mobile-main-toggle-group mb-3' : 'desktop-toggle-group'"
        [value]="userStatusFilter()"
        aria-label="User Status"
        name="user-status"
      >
        <mat-button-toggle
          class="test-user-status-current"
          value="current"
        >
          <span class="item-status-title">Current</span>
        </mat-button-toggle>
        <mat-button-toggle
          class="test-user-status-archived"
          value="archived"
        >
          <span class="item-status-title">Archived</span>
        </mat-button-toggle>
      </mat-button-toggle-group>
      @if (isMobile()) {
        <a
          class="btn-green btn-medium w-10 absolute right-0 top-0 p-0"
          [showForClientAdmin]="true"
          avsRestrictedEl
          routerLink="add-new-user"
        >
          <mat-icon fontIcon="add" />
        </a>
      }
      <app-search-input
        (searchDataEvent)="search.set($event)"
        [class]="isMobile() ? 'block w-full' : ''"
        [inputWidth]="isMobile() ? '100%' : '256px'"
        placeholder="Enter User Name or E-mail"
      />
    </div>
  </div>
  <cdk-virtual-scroll-viewport
    class="overflow-auto"
    [changeTrigger]="dataSource.filteredData"
    [ngClass]="{
      'fill-available-height': fillAvailableHeight(),
      'fixed-scroll': isInjected() && !fillAvailableHeight(),
    }"
    [tableId]="tableId()"
    avsVirtualTableScrollNormalizer
    itemSize="1"
  >
    <cdk-virtual-scroll-viewport-wrapper>
      <table
        id="users-table"
        class="main-table"
        [dataSource]="dataSource"
        [ngClass]="{ 'no-actions-table': userRole() === eUserRolesIds.ReadOnly }"
        #tableContent
        mat-table
        matSort
        matSortActive="firstName"
        matSortDirection="asc"
      >
        <!-- Number Column -->
        <ng-container matColumnDef="index">
          <th
            *matHeaderCellDef
            mat-header-cell
          >№</th>
          <td
            *matCellDef="let index = index"
            mat-cell
          >
            {{ index + 1 }}
          </td>
        </ng-container>

        <!-- User Name Column -->
        <ng-container matColumnDef="firstName">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
            sortActionDescription="Sort by User Name"
          >Name</th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            <a
              class="underline"
              [routerLink]="['/user-management', element.id]"
            >
              {{ element.firstName }} {{ element.lastName }}
            </a>
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
            sortActionDescription="Sort by status"
          >Status</th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            <app-user-status [status]="element.totpExpired ? eUserStatus.BLOCKED : element.status" />
          </td>
        </ng-container>

        <!-- 2FA Status Column -->
        <ng-container matColumnDef="totpStatus">
          <th
            *matHeaderCellDef
            mat-header-cell
          >2FA Status</th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            @if (element.totpEnabled) {
              <span>Active</span>
            } @else if (element.totpExpired) {
              <span class="text-red-500">Expired</span>
            } @else {
              <span>Pending</span>
            }
          </td>
        </ng-container>

        <!-- Role Column -->
        <ng-container matColumnDef="role">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
            sortActionDescription="Sort by role"
          >Role</th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            {{ $any(eRoleNames)[element.role.name] || 'Role is Undefined' }}
          </td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
            sortActionDescription="Sort by email"
          >Email</th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            {{ element.email }}
          </td>
        </ng-container>

        <!-- Phone Column -->
        <ng-container matColumnDef="phoneNumber">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
            sortActionDescription="Sort by phone"
          >Phone</th>
          <td
            class="text-nowrap"
            *matCellDef="let element"
            mat-cell
          >
            @if (element?.phone.number) {
              {{ element.phone.number | formatPhoneNumber : element.phone.countryCode : true }}
            } @else { - }
          </td>
        </ng-container>

        <!-- Last login Column -->
        <ng-container matColumnDef="lastLogin">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
            sortActionDescription="Sort by Last login"
          >Last login</th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            @if (element.lastLogin) {
              <span>{{ element.lastLogin | date : 'MM/dd/yy - hh:mm a' }}</span>
            } @else {
              <span>Never</span>
            }
          </td>
        </ng-container>

        <!-- Archive Column -->
        <ng-container matColumnDef="archive">
          <th
            [showForClientAdmin]="true"
            *matHeaderCellDef
            avsRestrictedEl
            mat-header-cell
          ></th>
          <td
            [showForClientAdmin]="true"
            *matCellDef="let element"
            avsRestrictedEl
            mat-cell
          >
            @if (editor()?.id !== element.id) {
              <div class="test-user-actions flex items-center justify-end">
                @if (element.status === ClientUserStatus.INVITED) {
                  <i
                    class="icon-resend-email action-icon mr-2"
                    (click)="resendInvitation(element)"
                    matTooltip="Resend Invitation"
                  ></i>
                }
                @if (userStatusFilter() !== ClientUserStatus.ARCHIVED) {
                  <i
                    class="icon-add-to-archive action-icon"
                    (click)="archiveUser(element)"
                    matTooltip="Archive"
                  ></i>
                }
                @if (userStatusFilter() === ClientUserStatus.ARCHIVED) {
                  <i
                    class="action-icon icon-restore"
                    (click)="restoreUser(element)"
                    matTooltip="Restore"
                  ></i>
                }
                @if (currentClient()?.requireTotp && userStatusFilter() !== ClientUserStatus.ARCHIVED) {
                  <mat-icon
                    class="action-icon mr-2"
                    (click)="resetTotp(element)"
                    fontIcon="lock_reset"
                    matTooltip="Reset 2FA"
                  />
                }
              </div>
            }
          </td>
        </ng-container>
        <tr
          *matHeaderRowDef="displayedColumns(); sticky: true"
          mat-header-row
        ></tr>
        <tr
          *matRowDef="let row; columns: displayedColumns()"
          mat-row
        ></tr>
      </table>
    </cdk-virtual-scroll-viewport-wrapper>
    @if (!dataSource.filteredData.length) {
      <avs-no-data-placeholder
        [resultContent]="!!dataSource.data.length"
        noDataText="No users yet"
      />
    }
  </cdk-virtual-scroll-viewport>
} @else {
  <app-skeleton-table />
}
